import { useScrollAnimation } from '../../../hooks/useScrollAnimation';

export default function About() {
  const { ref, isVisible } = useScrollAnimation();

  return (
    <section id="about" className="py-32 bg-charcoal-light">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div
          ref={ref}
          className={`grid grid-cols-1 lg:grid-cols-2 gap-16 lg:gap-24 items-center transition-all duration-1000 ${
            isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'
          }`}
        >
          {/* Text Side */}
          <div>
            <span className="text-gold text-[10px] font-semibold tracking-[0.35em] uppercase mb-5 block">
              Who We Are
            </span>
            <h2 className="font-heading text-4xl md:text-5xl font-light text-white leading-tight mb-6">
              A Global Bridge Between<br />
              <em className="not-italic text-gold">China & The World</em>
            </h2>
            <div className="section-divider mb-8" />
            <p className="text-[#9A9A9A] text-sm leading-relaxed mb-5 tracking-wide">
              ABUMI Trading Company Limited is a Hong Kong-based international export and sourcing company dedicated to connecting global markets with reliable supply solutions from China.
            </p>
            <p className="text-[#9A9A9A] text-sm leading-relaxed mb-5 tracking-wide">
              We specialize in vehicles, construction machinery, and full project procurement for hotels, villas, and large developments.
            </p>
            <p className="text-[#9A9A9A] text-sm leading-relaxed tracking-wide">
              With strong supplier networks and cross-border experience, we deliver efficient, cost-effective, and reliable solutions.
            </p>

            {/* Stats */}
            <div className="grid grid-cols-3 gap-6 mt-12 pt-10 border-t border-charcoal-border">
              {[
                { value: '10+', label: 'Years Experience' },
                { value: '3', label: 'Active Markets' },
                { value: '100+', label: 'Projects Delivered' },
              ].map((stat) => (
                <div key={stat.label}>
                  <div className="font-heading text-3xl text-gold font-light">{stat.value}</div>
                  <div className="text-[10px] text-charcoal-text tracking-[0.15em] uppercase mt-1">{stat.label}</div>
                </div>
              ))}
            </div>
          </div>

          {/* Image Side */}
          <div className="relative">
            <div className="w-full h-[520px] overflow-hidden">
              <img
                src="https://public.readdy.ai/ai/img_res/55f3a5374f3beb9d4ed755d10ecf0257.jpg"
                alt="Hong Kong - ABUMI Headquarters"
                className="w-full h-full object-cover object-top"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-charcoal-light/60 via-transparent to-transparent" />
            </div>
            {/* Gold accent border */}
            <div className="absolute -bottom-4 -right-4 w-full h-full border border-gold/20 -z-10" />
            {/* Tag */}
            <div className="absolute bottom-6 left-6 bg-charcoal/90 backdrop-blur-sm border border-charcoal-border px-5 py-4">
              <div className="text-[10px] text-gold tracking-[0.2em] uppercase font-medium">Headquartered</div>
              <div className="text-white text-sm font-heading mt-0.5">Hong Kong, China</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
